// Mapeamento puro reason -> texto do 409 { conflict: "contato_existente" }
// (PUT /contatos/celular, Efetivar e Cadastrar contato). Nenhum texto promete
// renomear contato; todos deixam claro que nada foi alterado. CPF nunca é
// exibido e nada aqui escreve em console.

export const CONTACT_CONFLICT_CODE = "contato_existente";

const FALLBACK_REASON = "desconhecido";

// Textos em pt (fallback e fonte do teste). As chaves i18n ficam em
// translations.contactConflict.* nos arquivos de idioma.
export const CONTACT_CONFLICT_TEXTS = {
  nome_real_cpf_diferente:
    "Este celular já pertence a um contato com nome real e CPF diferente. Nada foi alterado. Confira se o número está correto ou se é um número compartilhado (ex.: familiar); nesse caso, mantenha o contato existente.",
  nome_real_sem_cpf:
    "Este celular já pertence a um contato com nome real e sem CPF. Nada foi alterado. Confira se é o mesmo cliente.",
  varios_nomes_reais:
    "Este celular está em mais de um contato com nome real. Nada foi alterado. Resolva primeiro o contato duplicado.",
  cpf_existente: "Já existe um contato com o CPF deste cliente.",
  [FALLBACK_REASON]: "Este celular já está cadastrado em outro contato. Nada foi alterado.",
};

export const isContactConflict = (data) =>
  !!data && typeof data === "object" && data.conflict === CONTACT_CONFLICT_CODE;

const normalizeReason = (reason) =>
  typeof reason === "string" && Object.prototype.hasOwnProperty.call(CONTACT_CONFLICT_TEXTS, reason)
    ? reason
    : FALLBACK_REASON;

export const getConflictI18nKey = (reason) => `contactConflict.${normalizeReason(reason)}`;

// t opcional (i18n.t): sem ele devolve o texto em pt.
export const getConflictText = (reason, t) => {
  const key = normalizeReason(reason);
  const fallback = CONTACT_CONFLICT_TEXTS[key];
  return typeof t === "function" ? t(getConflictI18nKey(reason), { defaultValue: fallback }) : fallback;
};

// Normaliza o corpo do 409. Só mantém reason, ids inteiros positivos e
// contactName (string) — qualquer outro campo (ex.: CPF) é descartado.
export const parseContactConflict = (data) => {
  if (!isContactConflict(data)) return null;
  const contactIds = Array.isArray(data.contactIds)
    ? data.contactIds.filter((id) => Number.isInteger(id) && id > 0)
    : [];
  const contactName =
    typeof data.contactName === "string" && data.contactName ? data.contactName : undefined;
  return { reason: normalizeReason(data.reason), contactIds, ...(contactName ? { contactName } : {}) };
};
